import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description: string;
  keywords: string;
}

function setMetaTag(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    document.title = title;
    setMetaTag("description", description);
    setMetaTag("keywords", keywords);
  }, [title, description, keywords]);
}